
import { Bell } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Notification } from "@/types";

interface NotificationsListProps {
  notifications: Notification[];
  onMarkAsRead: (notificationId: string) => void;
}

const NotificationsList = ({ notifications, onMarkAsRead }: NotificationsListProps) => {
  return (
    <Card>
      <CardContent className="p-0">
        <div className="divide-y">
          {notifications.length === 0 ? (
            <div className="p-4 text-center text-muted-foreground">
              No notifications to display
            </div>
          ) : (
            notifications.map((notification) => (
              <div 
                key={notification.id} 
                className={`p-4 flex items-start ${notification.isRead ? '' : 'bg-muted/20'}`}
                onClick={() => onMarkAsRead(notification.id)}
              >
                <Bell className="h-5 w-5 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm">{notification.message}</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {new Date(notification.createdAt).toLocaleString()}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationsList;
